import { useTranslate } from "../i18n/useTranslationModules";
import { Session, SessionPreview, SessionTypesEnum } from "../types/working-model";

export const useGetGoToSessionButtonText = (session: SessionPreview | Session, isLive: boolean) => {
	const { t } = useTranslate(["homepage", "landing"]);
	const { session_type} = session;
	
	switch (session_type) {
		case SessionTypesEnum.fireside:
		case SessionTypesEnum.broadcast:
			return isLive ? t('homepage:Watch', "") : t('homepage:Details', "");
		case SessionTypesEnum.breakoutRooms:
			return isLive ? t('homepage:Join', "") : t('homepage:Details', "");
		default:
			return t('homepage:Watch', "");
	}
};